import React from "react";
import { HighlightedSkills } from ".././data/SkillsData";

const Language = ({ language }) => {
  return (
    <div className="col mb-4 mb-md-0">
      <div
        className={`d-flex align-items-center justify-content-center rounded-4 p-3 h-100 fw-semibold shadow-sm ${
          HighlightedSkills.includes(language)
            ? "bg-gradient-primary-to-secondary text-white"
            : "bg-light"
        }`}
      >
        {language}
      </div>
    </div>
  );
};

export default Language;
